import { ValueGetterParams } from '@ag-grid-community/core'
import { ClearwaterTransaction } from '@helios/common-api'

const linkedState = {
  matched: ['mdi-vector-link', 'Matched'],
  matchedToCustody: ['mdi-bank', 'Matched to Custody'],
  matchedToTrade: ['mdi-certificate', 'Matched to Trade'],
  unmatched: ['mdi-card-remove-outline', 'Unmatched'],
}

/**
 *
 */
export function isLinked({
  custodyLinkedStatus,
  tradingLinkedStatus,
}: ClearwaterTransaction) {
  return custodyLinkedStatus ?? tradingLinkedStatus ?? false
}

/**
 * Get the link status values
 */
export function linkStatusValueGetter(params: ValueGetterParams) {
  const data: ClearwaterTransaction = params.data
  if (data == null) return ''

  if (data.custodyLinkedStatus && data.tradingLinkedStatus) {
    return linkedState.matched[1]
  } else if (data.custodyLinkedStatus) {
    return linkedState.matchedToCustody[1]
  } else if (data.tradingLinkedStatus) {
    return linkedState.matchedToTrade[1]
  } else {
    return linkedState.unmatched[1]
  }
}
